module.exports = __webpack_public_path__ + "static/media/avatar-caleb.849ec027.png";